/**
 * Membership module routes.
 * For portal / shared route constants, use @kivunova/kivufrontendcommon.
 */

// Base path for membership
export const MEMBERSHIP_BASE = "/membership";

// Route definitions for MembershipRoutes (relative to mount point)
export const ROUTE_DEF_HOME = "/";
export const ROUTE_DEF_PLANS = "plans";
export const ROUTE_DEF_PLAN_DETAIL = "plans/:planId";
export const ROUTE_DEF_SUBSCRIPTIONS = "subscriptions";
export const ROUTE_DEF_SUBSCRIPTION_DETAIL = "subscriptions/:subscriptionId";
export const ROUTE_DEF_PAYMENTS = "payments";
export const ROUTE_DEF_PAYMENT_DETAIL = "payments/:paymentId";
export const ROUTE_DEF_ORDER_SUMMARY = "order-summary";
export const ROUTE_DEF_CHECKOUT = "checkout/:subscriptionId";
export const ROUTE_DEF_SUCCESS = "success/:subscriptionId";
export const ROUTE_DEF_PARTIAL_SUCCESS = "partial-success/:subscriptionId";

// Absolute paths for navigation (use with navigate())
export const ROUTE_HOME = MEMBERSHIP_BASE;
export const ROUTE_PLANS = `${MEMBERSHIP_BASE}/plans`;
export const ROUTE_SUBSCRIPTIONS = `${MEMBERSHIP_BASE}/subscriptions`;
export const ROUTE_PAYMENTS = `${MEMBERSHIP_BASE}/payments`;
export const ROUTE_ORDER_SUMMARY = `${MEMBERSHIP_BASE}/order-summary`;
export const ROUTE_CHECKOUT = `${MEMBERSHIP_BASE}/checkout`;
export const ROUTE_SUCCESS = `${MEMBERSHIP_BASE}/success`;
export const ROUTE_PARTIAL_SUCCESS = `${MEMBERSHIP_BASE}/partial-success`;

// Helper functions to build absolute paths with IDs
export const getSuccessPath = (subscriptionId: string) =>
  `${MEMBERSHIP_BASE}/success/${subscriptionId}`;
export const getPartialSuccessPath = (subscriptionId: string) =>
  `${MEMBERSHIP_BASE}/partial-success/${subscriptionId}`;
export const getPlanDetailPath = (planId: string) =>
  `${MEMBERSHIP_BASE}/plans/${planId}`;
export const getSubscriptionDetailPath = (subscriptionId: string) =>
  `${MEMBERSHIP_BASE}/subscriptions/${subscriptionId}`;
export const getPaymentDetailPath = (paymentId: string) =>
  `${MEMBERSHIP_BASE}/payments/${paymentId}`;
export const getCheckoutPath = (subscriptionId: string) =>
  `${MEMBERSHIP_BASE}/checkout/${subscriptionId}`;
